export const USER_ROUTES = {
    RELEASE: "release",
    RELEASE_NEW: "new"
};
